import { useNavigate } from "@tanstack/react-router";
import { DataTable } from "../../components/DataTable";

const columns = [
  { accessorKey: "id", header: "Code", meta: { minWidth: 200 } },
  {
    accessorKey: "description",
    header: "Description",
    meta: { minWidth: 400 },
  },
  {
    accessorKey: "staffAssigned",
    header: "Staff Assigned",
    meta: { minWidth: 150 },
  },
  { accessorKey: "coreItems", header: "Core Items", meta: { minWidth: 150 } },
  {
    accessorKey: "accesoryItems",
    header: "Accessory Items",
    meta: { minWidth: 150 },
  },
];

export const WardrobeTable = ({
  wardrobes,
  wardrobeFilter,
  setWardrobeFilter,
  loading,
}) => {
  const navigate = useNavigate();

  const wardrobeList = wardrobes?.wardrobe || [];
  const rowCount = Number(wardrobes?.paging?.noOfRecords) || 0;

  const pagination = {
    page: (wardrobeFilter?.page ?? 1) - 1,
    pageSize: wardrobeFilter?.pageSize ?? 25,
  };

  const handlePaginationChange = (next) => {
    setWardrobeFilter((prevState) => ({
      ...prevState,
      page: next.page + 1,
      pageSize: next.pageSize,
    }));
  };

  return (
    <DataTable
      aria-label="Wardrobes"
      columns={columns}
      rows={wardrobeList}
      getRowId={(row) => row.id}
      rowCount={rowCount}
      page={pagination.page}
      pageSize={pagination.pageSize}
      loading={loading}
      onPaginationChange={handlePaginationChange}
      onRowClick={(row) => navigate({ to: `/wardrobes/${row.id}` })}
    />
  );
};
